<template>
    <div class="index">
        <van-nav-bar
            title="用户观看记录"
            fixed
            placeholder
            left-arrow
            @click-left="onClickLeft"
        />
        <van-search
            style="margin-bottom: var(--base-px-12)"
            v-model="nickname"
            show-action
            placeholder="请输入用户名称"
            @search="onSearch"
        >
            <template #action>
                <van-button  type="info" icon="search" size="small" @click="onSearch">搜索</van-button>
            </template>
        </van-search>
        <div class="content">
            <List
            v-model="loading"
            :finished="finished"
            :error="loadError"
            :error-text="loadErrorText"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <div v-for="item in list" :key="item.id" class="user-card">
                <div class="user-card-content">
                    <img
                        class="user-avatar"
                        :src="item.avatar"
                        alt="用户头像"
                    />
                    <div class="user-info">
                        <div class="user-name">{{ item.nickname }}</div>
                        <div class="user-details">
                            <div class="detail-item">
                                <span class="detail-label">观看时长：</span>
                                <span class="detail-value"
                                    >{{ item.duration }}秒</span
                                >
                            </div>
                            <div
                                class="detail-item"
                                v-if="item.province || item.city"
                            >
                                <span class="detail-label">地区：</span>
                                <span class="detail-value">
                                    {{ item.province }}-{{ item.city }}
                                </span>
                            </div>
                            <div class="detail-btns">
                                <van-button
                                    type="primary"
                                    size="small"
                                    v-if="item.is_reissue != 1"
                                    @click="oneResendRedPacket(item.id)"
                                    >补发红包</van-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </List>
        </div>
        
    </div>
</template>
<script>
import { List } from "vant";
import { qunView, reissueRed } from "@/api/live";
export default {
    name: "watchData",
    components: {
        List,
    },
    data() {
        return {
            id: "",
            pages: 1,
            page_size: 10,
            total: 0,
            list: [],
            finished: false,
            loading: false,
            loadError: false,
            loadErrorText: "",
            isFlag: false,
            nickname: "",
        };
    },
    created() {
        this.id = this.$route.query.id;
        this.getList();
    },
    methods: {
        onClickLeft() {
            this.$router.back();
        },
        onSearch() {
            this.pages = 1;
            this.list = [];
            this.finished = false;
            this.loading = false;
            this.loadError = false;
            this.loadErrorText = "";
            this.getList();
        },
        onLoad() {
            this.pages++;
            this.getList();
        },
        oneResendRedPacket(id) {
            this.$dialog
                .confirm({
                    title: "提示",
                    message: "确定要补发红包吗？",
                })
                .then((res) => {
                    if (res) {
                        this.resendRedPacket(id);
                    }
                });
        },
        resendRedPacket(id) {
            if (this.isFlag) {
                return;
            }
            this.isFlag = true;
            reissueRed({
                id: id,
            })
                .then((res) => {
                    console.log(res);
                    if (res.code == 1) {
                        this.$toast.success(res.msg);
                        this.getList();
                    } else {
                        this.$toast.fail(res.msg);
                    }
                })
                .finally(() => {
                    setTimeout(() => {
                        this.isFlag = false;
                    }, 1500);
                });
        },
        getList() {
            this.loading = true;
            qunView({
                page: this.pages,
                room_id: this.id,
                nickname: this.nickname,
            })
                .then((res) => {
                    if (res.code == 1) {
                        if (res.data.count <= this.pages * 10) {
                            this.finished = true;
                        } else {
                            this.finished = false;
                        }
                        if(this.pages==1){
                            this.list = []
                        }
                        this.list = [...this.list, ...res.data.list];
                        this.total = res.data.total;
                        this.loadError = false;
                        this.loadErrorText = "";
                    } else {
                        this.$toast.fail(res.msg);
                        this.loadError = true;
                        this.loadErrorText = res.msg;
                    }
                    this.loading = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
<style scoped lang="less">
.index {
    background: #f5f5f5;
    min-height: 100vh;
}
.content{
    padding: var(--base-px-12);
}
.user-card {
    background: #ffffff;
    border-radius: var(--base-px-8);
    margin-bottom: var(--base-px-12);
    padding: var(--base-px-16);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.user-card-content {
    display: flex;
    align-items: flex-start;
}

.user-avatar {
    width: var(--base-px-52);
    height: var(--base-px-52);
    border-radius: var(--base-px-100);
    margin-right: var(--base-px-12);
    flex-shrink: 0;
    object-fit: cover;
    background: #f0f0f0;
}

.user-info {
    flex: 1;
    min-width: 0;
}

.user-name {
    font-size: var(--base-px-16);
    font-weight: 500;
    color: #333333;
    margin-bottom: var(--base-px-8);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.user-details {
    display: flex;
    flex-direction: column;
    gap: var(--base-px-6);
}

.detail-item {
    font-size: var(--base-px-14);
    color: #666666;
    display: flex;
    align-items: center;
}

.detail-label {
    color: #999999;
    margin-right: var(--base-px-4);
}

.detail-value {
    color: #333333;
}
.detail-btns {
    display: flex;
    justify-content: flex-end;
    margin-top: var(--base-px-10);
}
/deep/ .van-search__action {
    line-height: 0;
}
</style>
